// extracted by mini-css-extract-plugin
module.exports = {"root":"Dialog_root__2EMQ-","dialog":"Dialog_dialog__lhzch","header":"Dialog_header__28ETu","body":"Dialog_body__3OwmC","footer":"Dialog_footer__1SmSq"};